export const PHONE_REGEX = new RegExp(
  /^(?:0|98|\+98|\+980|0098|098|00980)?(9\d{9})$/,
);
